import type { ActionCandidate } from "../../../types/candidate";
import * as R from "remeda";
import { INPUT_APPLICATION_ID } from "../../../utils/constants";

export const ejectDependValues = (
  action: ActionCandidate,
  applicationId?: string,
): ActionCandidate => ({
  ...action,
  inputs: R.map(action.inputs, (input) => {
    if (input.inputId === "export-type") {
      input.value = undefined;
    }
    if (input.inputId === INPUT_APPLICATION_ID && applicationId !== undefined) {
      input.value = {
        values: [
          {
            value: {
              oneofKind: "string",
              string: applicationId,
            },
          },
        ],
      };
    }

    return input;
  }),
});
